import { createSlice } from "@reduxjs/toolkit";
const afState = {
  afUserId: "",
};
export const afSlice = createSlice({
  name: "af",
  initialState: afState,
  reducers: {
    setAfUserId(state, action) {
      state.afUserId = action.payload;
    },
  },
});

export const { setAfUserId } = afSlice.actions;
